import { useCallback, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useLogs = () => {
  const { api, userID } = useContext(GlobalContext);

  const postRequest = useCallback(
    async (endpoint, body) => {
      const response = await api.post(endpoint, body);
      return response?.data;
    },
    [api]
  );

  const getCampaignLogs = useCallback(
    async (campaignId, status) => {
      return await postRequest(
        "/Whatsapp/v1.0/getWhatsappLogs",
        {
          userid: userID,
          campaignId,
          status,
        }
      );
    },
    [userID, postRequest]
  );

  const getAllMessageLogs = useCallback(
    async (payload) => {
      return await postRequest(
        "/Whatsapp/getAllWhatsappLogs",
        payload
      );
    },
    [postRequest]
  );

  return {
    getCampaignLogs,
    getAllMessageLogs,
  };
};

export default useLogs;